import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { StockPackingHistoryAction } from './stock-packing-history.actions';
import { StockPackingHistoryService } from '../../service/stock-packing-history.service';

@Injectable()
export class StockPackingHistoryEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private service: StockPackingHistoryService
  ) {}

  loadStockPackingHistoryListRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockPackingHistoryAction.requestList),
      tap((action) =>
        this.logger.debug('@Effect Stock Packing History List Requested: ' + JSON.stringify(action.criteriaObj))
      ),
      switchMap((action) => {
        return this.service.getStockPackingHistoryList(action.criteriaObj).pipe(
          map((data: any) => StockPackingHistoryAction.responseList({ data })),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
